import React from 'react';
import classNames from 'classnames';
import { COMMENT_BOX_PLACEHOLDER_TEXT } from '../../../../common/constants/data-hooks';
import { PlaceholderTooltip } from './placeholder-tooltip';
import { getIsMobile } from '../../../../common/store/base-params/base-params-selectors';
import { useApi } from '../../../api-provider';
import styles from './placeholder-text.module.scss';
export const PlaceholderText = ({ text }) => {
    const isTooltipEnabled = React.useRef(false);
    const containerNode = React.useRef(null);
    const textNode = React.useRef(null);
    const isMobile = useApi(getIsMobile);
    React.useEffect(() => {
        if (containerNode.current &&
            textNode.current &&
            containerNode.current.getBoundingClientRect().width <
                textNode.current.getBoundingClientRect().width) {
            isTooltipEnabled.current = true;
        }
    }, [text]);
    return (React.createElement(PlaceholderTooltip, { className: classNames(styles.root, isMobile && styles.isMobile), isEnabled: isTooltipEnabled.current, tooltip: React.createElement("div", { className: styles.tooltip }, text) },
        React.createElement("div", { ref: containerNode, className: styles.textContainer },
            React.createElement("span", { className: styles.comparisonNode, ref: textNode }, text),
            React.createElement("span", { "data-hook": COMMENT_BOX_PLACEHOLDER_TEXT }, text))));
};
//# sourceMappingURL=placeholder-text.js.map